import { render, staticRenderFns } from "./dialog-bedSelector.vue?vue&type=template&id=a40032c6"
import script from "./dialog-bedSelector.vue?vue&type=script&lang=js"
export * from "./dialog-bedSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports